import { createSlice, Draft } from "@reduxjs/toolkit";

export interface LoginResponseData {
  userAccountID: string;
  userName: string;
  firstName: string;
  middleName: string;
  lastName: string;
  emailAddress: string;
  employeeID: string;
  employerID: string;
  sootchyEmployerID: number;
  vestingScheduleName: string;
  onboardingProgress: string;
  isDefaultPasswordChanged: boolean;
  is2FAEnabled: boolean;
  employerMaxContribution: number;
  benefitContributionLimit: number;
  benefitPlanStartDate: string;
  employeeSalary: number;
  enrolledStatus: string;
  accountState: string;
  dateOfBirth: string;
}

export interface UserState {
  token: string;
  id: string;
  firstname: string;
  middlename: string;
  lastname: string;
  username: string;
  emailAddress: string;
  employeeID: string;
  employerID: string;
  sootchyEmployerID: string;
  vestingScheduleName: string;
  onboardingProgress: string;
  IsDefaultPasswordChanged: string;
  isDefaultDateOfBirth: boolean | null;
  employerMaxContribution: number;
  benefitContributionLimit: number;
  benefitPlanStartDate: string;
  employeeSalary: number;
}

const initialState: UserState = {
  token: "",
  id: "",
  firstname: "",
  middlename: "",
  lastname: "",
  username: "",
  emailAddress: "",
  employeeID: "",
  employerID: "",
  sootchyEmployerID: "",
  vestingScheduleName: "",
  onboardingProgress: "Unknown",
  IsDefaultPasswordChanged: "",
  isDefaultDateOfBirth: null,
  employerMaxContribution: 0,
  benefitContributionLimit: 0,
  benefitPlanStartDate: "",
  employeeSalary: 0,
};

export type User = typeof initialState;

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    addToken(
      state: Draft<typeof initialState>,
      action: { payload: string },
    ): void {
      state.token = action.payload;
    },
    addUserInformation(
      state: Draft<typeof initialState>,
      action: { payload: LoginResponseData },
    ): void {
      const d = action.payload;
      state.id = d.userAccountID;
      state.firstname = d.firstName;
      state.middlename = d.middleName;
      state.lastname = d.lastName;
      state.username = d.userName;
      state.emailAddress = d.emailAddress;
      state.employeeID = d.employeeID;
      state.employerID = d.employerID;
      state.sootchyEmployerID = String(d.sootchyEmployerID);
      state.vestingScheduleName = d.vestingScheduleName;
      state.onboardingProgress = d.onboardingProgress;
      state.IsDefaultPasswordChanged = String(d.isDefaultPasswordChanged);
      state.employerMaxContribution = d.employerMaxContribution;
      state.benefitContributionLimit = d.benefitContributionLimit;
      state.benefitPlanStartDate = d.benefitPlanStartDate;
      state.employeeSalary = d.employeeSalary;
    },

    updateDefaultPasswordStatus(state, action: { payload: string }) {
      state.IsDefaultPasswordChanged = action.payload;
    },

    updateOnboardingProgress(state, action: { payload: string }) {
      state.onboardingProgress = action.payload;
    },

    setIsDefaultDateOfBirth(state, action: { payload: boolean }) {
      state.isDefaultDateOfBirth = action.payload;
    },
  },
});

export const {
  addToken,
  addUserInformation,
  updateDefaultPasswordStatus,
  updateOnboardingProgress,
  setIsDefaultDateOfBirth,
} = userSlice.actions;
export default userSlice.reducer;
